export default "__VITE_ASSET__xa4C7bce__"